module.exports = __webpack_public_path__ + "fonts/Inter-400-greek46.eb1153e.woff2";